<shared-master-project-image-panel *ngFor="let project of projects.items" [project]="project" [size]="400">
</shared-master-project-image-panel>
